var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":`isSelected = ${_vm.isSelected}`},model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }